import { render, staticRenderFns } from "./cardTemplateVip33.vue?vue&type=template&id=4b86c68c&scoped=true&"
import script from "./cardTemplateVip33.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip33.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip33.vue?vue&type=style&index=0&id=4b86c68c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b86c68c",
  null
  
)

export default component.exports